import _                                         from 'underscore';
import React, { FC, ReactNode }                  from 'react';
import { CorvalUIColor, Size }                   from '@src/types';
import { StyledContainer, StyledContainerProps } from './StyledContainer';
import { Cell, Grid }                            from "styled-css-grid";
import { ItemWithIcon }                          from "@src/views/components/display/ItemWithIcon";
import { Button, Icon }                          from "semantic-ui-react";
import { UseIf }                                 from "@src/views/components/display/EqualValues";
import { runIfFunction }                         from "@src/util";


export interface ProgressionBarProps {
    containerProps?: StyledContainerProps,
    stepPositionMinWidth?: string,

    leftComponent?: ReactNode,
    showLeftComponent?: boolean,
    leftComponentReady?: boolean
    leftComponentDisabled?: boolean
    onLeftComponentClick?: any,

    centerComponent?: ReactNode,

    rightComponent?: ReactNode,
    showRightComponent?: boolean,
    rightComponentReady?: boolean
    rightComponentDisabled?: boolean
    onRightComponentClick?: any,
}

const defaultProps: ProgressionBarProps = {
    containerProps:         {},
    stepPositionMinWidth:   '20%',
    leftComponent:          'Previous',
    showLeftComponent:      true,
    leftComponentReady:     true,
    leftComponentDisabled:  false,
    onLeftComponentClick:   '',
    centerComponent:        '',
    rightComponent:         'Next',
    showRightComponent:     true,
    rightComponentReady:    true,
    rightComponentDisabled: false,
    onRightComponentClick:  '',
}

const ProgressionBar: FC<ProgressionBarProps> = ( props ) => {

    return (

        <StyledContainer
            rounded={ true }
            padding={ Size.SM }
            borderSize={ Size.SM }
            borderColor={ CorvalUIColor.DK_SCREEN_10 }
            bgColor={ CorvalUIColor.WHITE }
            { ...props.containerProps }>

            { props.children ?? (

                <Grid columns={ `minmax(${ props.stepPositionMinWidth },auto) 1fr minmax(${ props.stepPositionMinWidth },auto)` } columnGap={ '20px' }>

                    <Cell middle>

                        <UseIf x={ props.showLeftComponent } eq={ true }>
                            <>
                                { _.isString( props.leftComponent ) ? (

                                    <Button
                                        basic
                                        compact
                                        color={ props.leftComponentReady ? 'teal' : 'grey' }
                                        size={ 'small' }
                                        disabled={ props.leftComponentDisabled }
                                        onClick={ () => runIfFunction( props.onLeftComponentClick ) }
                                    ><ItemWithIcon iconComponent={ <Icon name={ 'chevron left' }/> }>{ props.leftComponent }</ItemWithIcon></Button>

                                ) : props.leftComponent }
                            </>
                        </UseIf>

                    </Cell>

                    <Cell middle>

                        { _.isString( props.centerComponent ) ? (

                            <div className={ 'text-center text--xs' }>
                                <strong>{ props.centerComponent }</strong>
                            </div>

                        ) : props.centerComponent }

                    </Cell>

                    <Cell middle>

                        <UseIf x={ props.showRightComponent } eq={ true }>
                            <>
                                { _.isString( props.rightComponent ) ? (

                                    <Button
                                        compact
                                        type={ 'button' }
                                        basic={ !props.rightComponentReady }
                                        color={ props.rightComponentReady ? 'teal' : 'grey' }
                                        size={ 'small' }
                                        disabled={ props.rightComponentDisabled }
                                        onClick={ () => runIfFunction( props.onRightComponentClick ) }
                                    ><ItemWithIcon iconComponent={ <Icon name={ 'chevron right' }/> }>{ props.rightComponent }</ItemWithIcon></Button>

                                ) : props.rightComponent }
                            </>
                        </UseIf>

                    </Cell>

                </Grid>

            ) }

        </StyledContainer>
    );
};

ProgressionBar.defaultProps = defaultProps;

export { ProgressionBar }
